<template>
    <actions-menu v-model:dialogDelete="dialog" :ShowDialogDelete="false" :ShowDialogEdit="false"
        :ShowDialogConsult="true" v-model:dialogConsult="ConsultDialog" :Id="Id" />
    <v-dialog v-model="ConsultDialog" v-if="ConsultDialog">
        <v-card width="950px" class="py-2" style="border-radius: 12px;">
            <h1 class="text-center dialog-title"> {{ $t('clients.documentsTab.consult') }}</h1>
            <form>
                <div class="row ma-4 mt-2 mb-2">
                    <div class="col-6 justify-content-start">
                        <div class="row">
                            <v-card-title class="text-left ma-0">{{ $t('clients.documentsTab.name') }}<span
                                    class="red">*</span>
                            </v-card-title>
                        </div>
                        <div class="row">
                            <v-text-field v-model="documentName" id="NameEdit" name="NameEdit"
                                :readonly="!validationButton" maxlength="30" hide-details persistent-placeholder
                                class='pe-none' variant="outlined"></v-text-field>
                        </div>
                    </div>
                    <div class="col-6 justify-content-start">
                        <div class="row">
                            <v-card-title class="text-left ma-0">{{ $t('clients.documentsTab.date') }}<span
                                    class="red">*</span>
                            </v-card-title>
                        </div>
                        <div class="row">
                            <dateField v-model="documentDate" :readonly="true" class='pe-none' />
                        </div>
                    </div>
                    <div class="col-12 justify-content-center mt-2 ">
                        <div class="row justify-content-center">
                            <v-card elevation="0" v-if="loadingImage" width="500">
                                <v-card-text class="d-flex justify-center align-center">
                                    <v-progress-circular indeterminate size="50"></v-progress-circular>
                                </v-card-text>
                            </v-card>
                        </div>
                        <div class="row justify-content-center">
                            <v-img :src="item.url" width="400" height="500" @load="loadingImage = false"
                                @error="loadingImage = false" v-show="!loading"></v-img>
                        </div>
                        
                    </div>
                </div>
                <v-card-actions class="justify-center">
                    <v-btn @click="ConsultDialog = false" class="border border-2 text-grey p-2"
                        style="width: 300px;height: 50px ;" rounded="lg" dark color="grey">
                        {{ $t('actions.cancel') }}
                    </v-btn>
                </v-card-actions>
            </form>
        </v-card>
    </v-dialog>

    <dialogDelete DialogType="ToCorrect" :title="$t('clients.client')" :yes="ToCorrectCustomer"
        v-model="dialogToCorrect" />
    <!--<dialogDelete :title="$t('clients.client')" :yes="DeleteCustomer" v-model="dialog" />-->
</template>
<script>
import actionsMenu from "@/genericComponent/actionsMenu.vue";
import DateField from "@/genericComponent/date-field.vue";
import DialogDelete from "@/genericComponent/dialogDelete.vue";


export default {
    name: "ClientItemMenu",
    components: { actionsMenu, DialogDelete, DateField },
    props: {
        isValidated: {},
        GetClientsAfterDeleted: {},
        Id: {},
        item: {}
    },
    data() {
        return {
            dialog: false,
            msg: [],
            isDisabled: true,
            ConsultDialog: false,
            view: true,
            documentName: this.item.name,
            documentDate: this.item.created.split('T')[0],
            loadingImage: true
        };
    },
    created() { },
    methods: {
        getParent(name) {
            let p = this.$parent;
            while (typeof p !== 'undefined') {
                if (p.$options.name == name) {
                    return p;
                } else {
                    p = p.$parent;
                }
            }
            return false;
        }
    }
};
</script>